var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCookies = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.655 1.293c-7.46 0-13.508 6.049-13.508 13.512 0 7.46 6.048 13.508 13.508 13.508 7.463 0 13.512-6.049 13.512-13.508 0-7.463-6.049-13.512-13.512-13.512Z",
    fill: "#D28147"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.266 11.687c-7.463 0-13.512 6.049-13.512 13.508 0 7.463 6.049 13.512 13.512 13.512 7.46 0 13.508-6.049 13.508-13.512 0-7.46-6.049-13.508-13.508-13.508Z",
    fill: "#F6B059"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.708 22.076a2.599 2.599 0 1 0-.002 5.198 2.599 2.599 0 0 0 .002-5.198Zm2.077-6.235a1.558 1.558 0 1 0 0 3.117 1.558 1.558 0 0 0 0-3.117Zm3.636 12.471a2.08 2.08 0 1 0 .006 4.16 2.08 2.08 0 0 0-.006-4.16ZM7.472 25.194a1.558 1.558 0 1 0 0 3.117 1.558 1.558 0 0 0 0-3.117Zm14.549-3.117a1.559 1.559 0 1 0-.001 3.117 1.559 1.559 0 0 0 0-3.117Zm-9.872 9.353a1.04 1.04 0 1 0 0 2.081 1.04 1.04 0 0 0 1.037-1.04 1.04 1.04 0 0 0-1.037-1.041Z",
    fill: "#6D420D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.539 5.452a2.077 2.077 0 1 0 0 4.154 2.077 2.077 0 1 0 0-4.154Zm5.717 5.195a1.558 1.558 0 1 0 0 3.117 1.558 1.558 0 0 0 0-3.117Zm1.037-6.236a1.558 1.558 0 1 0-.001 3.117 1.558 1.558 0 0 0 0-3.117Zm3.64 11.43c-.573 0-1.04.469-1.04 1.041 0 .573.467 1.041 1.04 1.041s1.04-.468 1.04-1.04c0-.573-.467-1.041-1.04-1.041Z",
    fill: "#7A441D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCookies);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cookies.c84a006c54fd7fba16ba8388cd3b4df2.svg";